var React = require('react');

function ChevronSmallInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.17177 5.00002L0.342773 2.17202L1.75677 0.757019L5.99977 5.00002L1.75677 9.24302L0.342773 7.82802L3.17177 5.00002Z","fill":"currentColor"}));
}

ChevronSmallInline.defaultProps = {"width":"6","height":"10","viewBox":"0 0 6 10","fill":"none"};

module.exports = ChevronSmallInline;

ChevronSmallInline.default = ChevronSmallInline;
